import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, switchMap } from 'rxjs';

const DEFAULT_LANG = 'pt';

/**
 * Loads i18n catalogs before the app renders so `instant()` / templates never
 * briefly show raw keys while the HTTP loader is still in flight.
 */
export function provideAppTranslations(): EnvironmentProviders {
    return provideAppInitializer(() => {
        const translate = inject(TranslateService);
        translate.addLangs([DEFAULT_LANG]);
        return firstValueFrom(translate.setFallbackLang(DEFAULT_LANG).pipe(switchMap(() => translate.use(DEFAULT_LANG))));
    });
}
